const textProps = {
  title: "Development Cycle",
  text:
    "You can create a lasting competitive advantage and sustainable business growth with a range of high-quality IT solutions tailored to your needs. Explore our full-cycle software development services.",
  icon: "fa fa-arrows-alt",
  color: "lightBlue",
};
export default textProps;
